/*
 * LOTR logo bar: the cart button opens the theme's own cart drawer (Dawn-family
 * <cart-drawer>, Archetype/Motion #CartDrawer, Horizon-family <cart-drawer-component>,
 * or window.LotrCartAdapter.open
 * if a theme provides one) and keeps its
 * count current after items are added or changed anywhere on the page.
 * Without either, the button stays a plain link to the cart page.
 */
if (!customElements.get('lotr-header')) {
  customElements.define(
    'lotr-header',
    class LotrHeader extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-lotr-bag]');
        this.count = this.querySelector('[data-lotr-count]');

        this.onClick = (event) => {
          const adapter = window.LotrCartAdapter;
          if (adapter && typeof adapter.open === 'function') {
            event.preventDefault();
            adapter.open(this.button);
            return;
          }
          // Archetype themes (Motion, Impulse, …): theme.CartDrawer opens on 'cart:open'.
          const t = window.theme;
          if (t && typeof t.CartDrawer === 'function' && document.getElementById('CartDrawer') && (!t.settings || t.settings.cartType === 'drawer')) {
            event.preventDefault();
            // The theme's own .js-drawer-open-cart handler normally opens it (with focus return);
            // open it ourselves only if that didn't happen, e.g. after a theme editor reload.
            setTimeout(() => {
              if (!document.documentElement.classList.contains('js-drawer-open')) {
                document.dispatchEvent(new CustomEvent('cart:open'));
              }
            });
            return;
          }
          // Dawn family <cart-drawer>, Horizon family <cart-drawer-component>.
          const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            event.preventDefault();
            drawer.open(this.button);
          } else if (drawer && typeof drawer.showDialog === 'function') {
            event.preventDefault();
            drawer.showDialog();
          }
        };
        this.refresh = () => this.refreshCount();

        this.button?.addEventListener('click', this.onClick);
        document.addEventListener('lotr:cart:added', this.refresh);
        document.addEventListener('cart:update', this.refresh);
        document.addEventListener('cart:updated', this.refresh);
        // Dawn publishes cart changes (drawer quantity edits, other product forms).
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
        }
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        document.removeEventListener('lotr:cart:added', this.refresh);
        document.removeEventListener('cart:update', this.refresh);
        document.removeEventListener('cart:updated', this.refresh);
        this.unsubscribe?.();
      }

      async refreshCount() {
        if (!this.count) return;
        try {
          const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
          const cart = await response.json();
          this.count.textContent = cart.item_count;
          this.button?.setAttribute('aria-label', this.dataset.labelTemplate.replace('[count]', cart.item_count));
        } catch (error) {
          // The count is cosmetic; the theme's own cart icon stays authoritative.
        }
      }
    }
  );
}
